import React, { useEffect, createElement } from 'react';
export function RedTrack() {
  useEffect(() => {
    // Inject RedTrack script into head
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://trk.armoniadelalma.com/track.js?rtkcmpid=69548db10c95eece3fca569c';
    script.async = true;
    document.head.appendChild(script);
    // Cleanup function
    return () => {
      // Remove script from head
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);
  return null;
}